import type { AppNavigator } from './AppNavigator';

export const getNavigatorApi = (appNavigator: AppNavigator) => ({
  navigate: appNavigator.dispatchNavigate,
  open: appNavigator.dispatchOpen,
  back: appNavigator.dispatchBack,
  replace: appNavigator.dispatchReplace,
  updateParams: appNavigator.dispatchUpdateParams,
});
